import trueTypeMiddleware from "./middleware";

export default trueTypeMiddleware;